import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getNewClubRegistrationStatus from './GetNewClubRegistrationStatusData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const NewClubRegistrationStatusData = {
  INITIAL_STATE,
  getNewClubRegistrationStatus
};

export default NewClubRegistrationStatusData;